import { render, staticRenderFns } from "./SongChart.vue?vue&type=template&id=5931d2cd&scoped=true"
import script from "./SongChart.vue?vue&type=script&lang=ts"
export * from "./SongChart.vue?vue&type=script&lang=ts"
import style0 from "./SongChart.vue?vue&type=style&index=0&id=5931d2cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5931d2cd",
  null
  
)

export default component.exports